// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DefaultPage-module--wrapper--2c8He","title":"DefaultPage-module--title--3HS3V","image":"DefaultPage-module--image--8D94-","text":"DefaultPage-module--text--1VuCM"};